module.exports = __webpack_public_path__ + "static/webexpo-a446c4ade65961400f76e5e5803e031a.png";